var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-update-table", attrs: { id: _vm.id } },
    [
      _c("div", { staticClass: "modal-update-table-wrap" }, [
        _c("img", { attrs: { src: require("@/assets/logo/icon-table.svg") } }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("p", { staticClass: "modal-update-table-subtitle" }, [
          _vm._v(_vm._s(_vm.tableName))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-update-table-button" },
          [
            _c(
              "b-button",
              {
                staticClass: "btn-blue",
                on: {
                  click: function($event) {
                    _vm.$emit("submit")
                  }
                }
              },
              [_vm._v("\n        Yes\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                on: {
                  click: function($event) {
                    _vm.$emit("close")
                  }
                }
              },
              [_vm._v("Cancel")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "modal-update-table-title" }, [
      _vm._v("\n      Are you sure to "),
      _c("span", [_vm._v("Update this Table")]),
      _vm._v(" ?\n    ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-723c2012", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-723c2012","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/jModalUpdateTable.vue
// module id = null
// module chunks = 